import { cn } from '@utils/cn';

import { Icon } from '@ui-component-library/components/Icon';
import { Text } from '@ui-component-library/components/Text';

import {
  checkboxIconClasses,
  hiddenInputClasses,
  labelClasses,
  selectorClasses
} from './Selector.styles';
import type { OptionProps, SelectorProps } from './Selector.types';

export const Selector = ({ children, className }: SelectorProps) => {
  return <div className={cn(selectorClasses(), className)}>{children}</div>;
};

export const Option = ({
  label,
  value,
  onClick,
  className,
  isSelected = false,
  disabled = false,
  disabledLabel,
  isValid,
  tabIndex = 0
}: OptionProps) => {
  const handleSelect = () => {
    onClick({ label, value });
  };

  return (
    <label
      className={cn(
        labelClasses({ selected: isSelected, disabled, validationStatus: isValid }),
        className
      )}
    >
      <input
        type="checkbox"
        className={cn(hiddenInputClasses())}
        onChange={handleSelect}
        tabIndex={tabIndex}
        disabled={disabled}
      />
      <Text variant="text-sm/leading-normal/medium" className="text[##0F0F0F]">
        {label}
      </Text>
      <Icon
        name="CheckSimple"
        size="medium"
        className={cn(checkboxIconClasses({ checked: isSelected }))}
      />
      {disabled && disabledLabel && (
        <Text variant="text-sm/leading-normal/medium" className="text-[#737373]">
          {disabledLabel}
        </Text>
      )}
    </label>
  );
};

Selector.Option = Option;
